import { Lock } from "lucide-react";

import { FEATURE_LABELS, type FeatureKey } from "@/constants/permissions";
import { cn } from "@/lib/utils";

interface PermissionNoticeProps {
  feature: FeatureKey;
  className?: string;
}

/**
 * Compact inline notice for widgets whose data requires a feature permission
 * the current member does not have. Communicates the gap upfront instead of
 * letting the widget fetch and fail.
 */
export function PermissionNotice({ feature, className }: PermissionNoticeProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-3 rounded-lg border border-dashed bg-muted/40 p-4",
        className
      )}
    >
      <Lock className="h-4 w-4 shrink-0 text-muted-foreground" />
      <p className="text-sm text-muted-foreground">
        Requires the {FEATURE_LABELS[feature].label} permission. Ask an organization
        admin to grant it to you.
      </p>
    </div>
  );
}
